// InputAlt component

import Input from '../../form/input/input.jsx'

class InputAlt extends Input {
  constructor (props) {
    super(props)

    this._inputClassName = 'form-inputalt'
  }
}

export default InputAlt
